import * as yup from 'yup';

export const validationSchema = yup.object().shape({
  editDataControl: yup.object().shape({
    dateValidity: yup.date().nullable().typeError('Data non valida').required('Campo obbligatorio'),
  }),
  cohabitationData: yup.object().shape({
    endCohabitationDate: yup
      .date()
      .nullable()
      .typeError('Data non valida')
      .required('Campo obbligatorio'),
    municipality: yup.object().shape({}).nullable().required('Campo obbligatorio'),
    professionist: yup.string().nullable(),
  }),
});
